import { useRef, useEffect, useState } from 'react'

import style from './fadein.module.scss'

const FadeIn = ({children, threshold = 0.1 }) => {
    const [isVisible, setIsVisible] = useState(false)
    const domRef = useRef()

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setIsVisible(true)
                    }
                })
            }, {threshold}
        )

        if (domRef.current) observer.observe(domRef.current)
    
        return () => {
            if (domRef.current) observer.unobserve(domRef.current)
        }
    }, [])

    return (
        <div
            ref={domRef}
            className={`${style.fadein} ${isVisible ? style.isVisible : ''}`}
        >
            {children}
        </div>
    )
}

export default FadeIn